import type { SpecChapter } from '../types';

export const ReportParagraphsRepository = Symbol.for('ReportParagraphsRepository');

export interface ReportParagraphsRepository {
    /**
     * 获取报告段落问题列表
     * @param taskId 任务 ID
     * @param abortSignal 取消信号
     */
    fetchSpecChapter(taskId: string, abortSignal?: AbortSignal): Promise<SpecChapter[]>;
}
